import { useMemo } from "react";

import {
  type DocumentAddressLabelPair,
  resolveBorderCanadaModalFieldLabels,
  resolveBorderUsConsigneeFieldLabel,
  resolveDocumentAddressLabels,
} from "~/shared/documents/document-address-labels";
import { api } from "~/utils/api";

/** Reads BOL address label mode for border create modals (SC-2971). */
export const useBolDocumentAddressLabels = () => {
  const labelsQuery = api.org.getBolDocumentAddressLabels.useQuery();

  const useConsignorConsigneeLabels = labelsQuery.data?.useConsignorConsigneeLabels ?? false;

  return useMemo(() => {
    const bolAddressLabels: DocumentAddressLabelPair = labelsQuery.data ?? resolveDocumentAddressLabels(false);

    return {
      isLoading: labelsQuery.isPending,
      useConsignorConsigneeLabels,
      bolAddressLabels,
      borderUsConsigneeFieldLabel: resolveBorderUsConsigneeFieldLabel(useConsignorConsigneeLabels),
      borderCanadaModalFieldLabels: resolveBorderCanadaModalFieldLabels(useConsignorConsigneeLabels),
    };
  }, [labelsQuery.data, labelsQuery.isPending, useConsignorConsigneeLabels]);
};
